'use client'

import { useGetGlobalContactDetailsAPIQuery } from "@/redux/rtkQueries/clientSideGetApis";
import { openModal } from "@/redux/slices/allModalSlice";
import Link from "next/link";
import { useDispatch } from "react-redux";

const OFFER_IMAGE_URL = "/images/home_data/offer.png";

interface SidebarSectionProps {
  bannerMinHeightPx?: number;
}

const SidebarSection = ({ bannerMinHeightPx }: SidebarSectionProps) => {
  const dispatch = useDispatch();
  const { data } = useGetGlobalContactDetailsAPIQuery();
  const GetGlobalContactDetails = data?.data;


    return (
        <div className="absolute top-0">
            <div
                className="hidden lg:flex border-lightSliver border-r border-b w-[6%] min-w-17 rounded-br-[30px] py-2 xl:py-6"
                style={bannerMinHeightPx ? { minHeight: bannerMinHeightPx } : undefined}
            >
                <div className="flex flex-col items-center justify-between w-full gap-5">
                    <div className="shrink-0 flex justify-between items-center flex-col gap-5">
                        <Link
                            href={GetGlobalContactDetails?.youtubeLink || 'www.youtube.com'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="home_banner_contact_text vertical_text_mirrored"
                        >
                            Youtube
                        </Link>
                        <Link
                            href={GetGlobalContactDetails?.instagramLink || 'www.instagram.com'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="home_banner_contact_text vertical_text_mirrored"
                        >
                            Instagram
                        </Link>
                        <Link
                            href={GetGlobalContactDetails?.facebookLink || 'www.facebook.com'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="home_banner_contact_text vertical_text_mirrored"
                        >
                            Facebook
                        </Link>
                    </div>

                    <Link
                        href={`tel:${GetGlobalContactDetails?.phoneNumber.replace(/\s/g, '')}`}
                        type="button"
                        className="rounded-full lets_talk_btn_shadow text-textf1! text-nowrap bg-white h-fit px-4 py-2 font-bold text-xs xl:text-[15px] 2xl:text-lg vertical_text_mirrored cursor-pointer hover:opacity-90 border-0"
                    >
                        Let's Talk
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default SidebarSection